<template>
  <div :class="containerClass">
    <incomplete-students />
    <recent-student-submissions />
    <incomplete-staff />
    <recent-staff-submissions />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const IncompleteStudents = () =>
  import("@/components/snapshots/IncompleteStudents.vue");
const IncompleteStaff = () =>
  import("@/components/snapshots/IncompleteStaff.vue");

const RecentStudentSubmissions = () =>
  import("@/components/snapshots/RecentStudentSubmissions.vue");
const RecentStaffSubmissions = () =>
  import("@/components/snapshots/RecentStaffSubmissions.vue");

export default {
  props: {
    horizontal: {
      type: Boolean,
      required: false
    }
  },

  data: () => {
    return {
      recentStudentSubmissionCount: 0,
      recentStudentSubmissions: [],
      snapshotDialog: false,
      snapshotTitle: "",
      snapshotLink: null,
      currentSnapshotComponent: null,
    };
  },
  components: {
    IncompleteStudents,
    IncompleteStaff,
    RecentStudentSubmissions,
    RecentStaffSubmissions,
  },
  mounted() {},
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    containerClass() {
      return {
        'd-flex': true,
        'flex-row': this.horizontal,
        'flex-column': !this.horizontal,
        'mx-2': true,
        'my-5': true,
        'justify-center': true
      };
    }
  },
  methods: {},
  
};
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* Adjust the breakpoint as needed */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }
}


</style>